'FRILLORA-FUYU-B2G1-20261104-v1';
(() => {
  'use strict';

  const selector = '.fr-pdp [data-b2g1], .fr-announcement';
  if (window.frPdpPromoHelp) {
    window.frPdpPromoHelp.refresh();
    return;
  }

  const messages = {
    en: ['Add the required eligible items to your bag. The offer applies automatically in your cart.', 'How this offer works', 'Close offer details'],
    ar: ['أضف العدد المطلوب من المنتجات المؤهلة إلى حقيبتك. يُطبَّق العرض تلقائيًا في سلة التسوق.', 'كيف يعمل هذا العرض', 'إغلاق تفاصيل العرض'],
    da: ['Læg det nødvendige antal kvalificerede varer i din indkøbskurv. Tilbuddet anvendes automatisk i kurven.', 'Sådan fungerer tilbuddet', 'Luk tilbudsdetaljer'],
    de: ['Lege die erforderlichen teilnehmenden Artikel in deinen Warenkorb. Das Angebot wird dort automatisch angewendet.', 'So funktioniert das Angebot', 'Angebotsdetails schließen'],
    es: ['Añade los artículos aptos necesarios a tu carrito. La oferta se aplica automáticamente en el carrito.', 'Cómo funciona esta oferta', 'Cerrar detalles de la oferta'],
    fr: ['Ajoutez le nombre requis d’articles éligibles à votre panier. L’offre s’applique automatiquement dans votre panier.', 'Comment fonctionne cette offre', 'Fermer les détails de l’offre'],
    he: ['הוסיפו לסל את הכמות הנדרשת של הפריטים הזכאים. ההטבה תחול אוטומטית בסל הקניות.', 'איך ההטבה פועלת', 'סגירת פרטי ההטבה'],
    it: ['Aggiungi al carrello il numero richiesto di articoli idonei. L’offerta si applica automaticamente nel carrello.', 'Come funziona questa offerta', 'Chiudi i dettagli dell’offerta'],
    ja: ['対象商品を必要な点数だけバッグに追加してください。特典はカート内で自動的に適用されます。', 'この特典の仕組み', '特典の詳細を閉じる'],
    nb: ['Legg det nødvendige antallet kvalifiserte varer i handlekurven. Tilbudet brukes automatisk i handlekurven.', 'Slik fungerer tilbudet', 'Lukk tilbudsdetaljer'],
    nl: ['Voeg het vereiste aantal deelnemende artikelen toe aan je winkelmandje. De aanbieding wordt automatisch toegepast in je winkelmandje.', 'Zo werkt deze aanbieding', 'Aanbiedingsdetails sluiten'],
    'pt-PT': ['Adicione ao carrinho a quantidade necessária de artigos elegíveis. A oferta é aplicada automaticamente no carrinho.', 'Como funciona esta oferta', 'Fechar os detalhes da oferta'],
    sv: ['Lägg till det antal kvalificerade varor som krävs i din varukorg. Erbjudandet tillämpas automatiskt i varukorgen.', 'Så fungerar erbjudandet', 'Stäng erbjudandedetaljer'],
  };
  const entries = new Map();
  let current = null;
  let sequence = 0;
  let frame = 0;

  const copyFor = trigger => {
    const language = String(trigger.dataset.b2g1Locale || document.documentElement.lang || window.Shopify?.locale || 'en').toLowerCase();
    const locale = Object.keys(messages).find(key => key.toLowerCase() === language)
      || ({ pt: 'pt-PT', no: 'nb' }[language])
      || (messages[language.split('-')[0]] ? language.split('-')[0] : 'en');
    const fallback = messages[locale];
    const scope = trigger.closest('.fr-pdp');
    const nodes = [...new Set([
      document.querySelector('script[data-fr-promo-help-config]'),
      scope?.querySelector('script[data-fr-pdp-interactions-config]'),
      document.querySelector('script[data-fr-pdp-interactions-config]'),
    ].filter(Boolean))];
    const configs = nodes.map(node => {
      try { return JSON.parse(node.textContent || '{}'); } catch { return {}; }
    });
    const text = (key, value) => {
      const config = configs.find(item => typeof item?.[key] === 'string' && item[key].trim()
        && !/^(?:translation missing:|translation_missing\b)/i.test(item[key].trim()));
      return config ? config[key].trim() : value;
    };
    return {
      message: document.querySelector('.fr-pdp [data-b2g1-buy="2"]') ? 'Choose any 3 eligible lingerie items. The lowest-priced item is free. Only eligible lingerie counts. This offer cannot be combined with the free-stocking offer.' : text('promoMessage', fallback[0]),
      label: text('promoLabel', fallback[1]),
      close: text('closeLabel', fallback[2]),
      locale,
    };
  };

  const visible = element => element?.isConnected && !element.hidden && element.getClientRects().length > 0
    && getComputedStyle(element).visibility === 'visible';
  const close = (restoreFocus = false) => {
    if (!current) return;
    const entry = current;
    current = null;
    entry.bubble.hidden = true;
    entry.trigger.setAttribute('aria-expanded', 'false');
    if (entry.description) entry.trigger.setAttribute('aria-describedby', entry.description);
    else entry.trigger.removeAttribute('aria-describedby');
    if (restoreFocus && visible(entry.trigger)) entry.trigger.focus({ preventScroll: true });
  };

  const position = () => {
    if (!current) return;
    const { trigger, bubble, announcement } = current;
    if (!visible(trigger)) {
      close();
      return;
    }
    const viewport = window.visualViewport;
    const bounds = {
      left: viewport?.offsetLeft || 0,
      top: viewport?.offsetTop || 0,
      width: viewport?.width || document.documentElement.clientWidth,
      height: viewport?.height || window.innerHeight,
    };
    const edge = 12;
    const gap = 10;
    const anchor = trigger.getBoundingClientRect();
    if (anchor.bottom <= bounds.top || anchor.top >= bounds.top + bounds.height || anchor.right <= bounds.left || anchor.left >= bounds.left + bounds.width) {
      close();
      return;
    }
    if (bubble.parentElement !== document.body) document.body.append(bubble);
    bubble.dataset.placement = announcement ? 'below' : 'above';
    bubble.style.maxWidth = `${Math.max(1, bounds.width - edge * 2)}px`;
    bubble.style.maxHeight = `${Math.max(1, bounds.height - edge * 2 - (announcement ? Math.max(0, anchor.bottom + gap - bounds.top - edge) : 0))}px`;
    const box = bubble.getBoundingClientRect();
    const preferredLeft = announcement ? bounds.left + (bounds.width - box.width) / 2 : anchor.left;
    const left = Math.max(bounds.left + edge, Math.min(preferredLeft, bounds.left + bounds.width - box.width - edge));
    const form = trigger.closest('form');
    const blockers = [...new Set([
      ...(form?.querySelectorAll('button[type="submit"], input[type="submit"]') || []),
      ...document.querySelectorAll('.fr-pdp-actions, [data-mobile-atc]'),
    ])].filter(visible).map(element => element.getBoundingClientRect());
    const fits = top => top >= bounds.top + edge && top + box.height <= bounds.top + bounds.height - edge
      && !blockers.some(rect => left < rect.right && left + box.width > rect.left && top < rect.bottom && top + box.height > rect.top);
    const above = anchor.top - box.height - gap;
    const below = anchor.bottom + gap;
    const top = announcement
      ? [below, ...blockers.map(rect => rect.bottom + gap)].filter(value => value >= below).find(fits) ?? null
      : fits(above) ? above : fits(below) ? below : null;
    if (top === null) {
      if (announcement) {
        close();
        return;
      }
      bubble.dataset.placement = 'inline';
      trigger.after(bubble);
      bubble.style.removeProperty('left');
      bubble.style.removeProperty('top');
      return;
    }
    bubble.dataset.placement = !announcement && top === above ? 'above' : 'below';
    bubble.style.left = `${left}px`;
    bubble.style.top = `${top}px`;
  };

  const schedulePosition = () => {
    if (!current || frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      position();
    });
  };

  const open = entry => {
    if (current === entry) {
      close();
      return;
    }
    close();
    const copy = copyFor(entry.trigger);
    entry.message.textContent = copy.message;
    entry.bubble.setAttribute('aria-label', copy.label);
    entry.bubble.lang = copy.locale;
    entry.bubble.dir = ['ar', 'he'].includes(copy.locale) ? 'rtl' : 'ltr';
    entry.closeButton.setAttribute('aria-label', copy.close);
    entry.trigger.setAttribute('aria-description', copy.label);
    entry.bubble.hidden = false;
    entry.trigger.setAttribute('aria-expanded', 'true');
    entry.trigger.setAttribute('aria-describedby', [entry.description, entry.message.id].filter(Boolean).join(' '));
    current = entry;
    position();
  };

  const init = scope => {
    const triggers = [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
    triggers.forEach(trigger => {
      if (entries.has(trigger)) return;
      const copy = copyFor(trigger);
      const bubble = document.createElement('div');
      do { bubble.id = `fr-pdp-promo-help-${++sequence}`; } while (document.getElementById(bubble.id));
      bubble.className = 'fr-pdp-promo-help';
      bubble.hidden = true;
      bubble.setAttribute('role', 'region');
      bubble.setAttribute('aria-label', copy.label);
      bubble.setAttribute('aria-live', 'polite');
      const message = document.createElement('p');
      message.id = `${bubble.id}-message`;
      message.className = 'fr-pdp-promo-help__message';
      message.textContent = copy.message;
      const closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'fr-pdp-promo-help__close';
      closeButton.setAttribute('aria-label', copy.close);
      closeButton.textContent = '×';
      bubble.append(message, closeButton);
      document.body.append(bubble);
      const announcement = trigger.matches('.fr-announcement');
      trigger.classList.add(announcement ? 'fr-announcement-promo-help-trigger' : 'fr-pdp-promo-help-trigger');
      if (!trigger.matches('button, a[href]')) trigger.setAttribute('role', 'button');
      if (!trigger.hasAttribute('tabindex') && !trigger.matches('button, a[href]')) trigger.tabIndex = 0;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', bubble.id);
      trigger.setAttribute('aria-description', copy.label);
      const controller = new AbortController();
      const entry = { trigger, bubble, message, closeButton, controller, announcement, description: trigger.getAttribute('aria-describedby') || '' };
      entries.set(trigger, entry);
      const triggerControls = () => [...trigger.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')].filter(visible);
      trigger.addEventListener('click', event => {
        if (event.target.closest('button, a[href], input, select, textarea, summary') && event.target !== trigger) {
          if (current === entry) close();
          return;
        }
        open(entry);
      }, { signal: controller.signal });
      trigger.addEventListener('keydown', event => {
        if (event.key === 'Tab' && !event.shiftKey && current === entry && bubble.parentElement === document.body && event.target === (triggerControls().at(-1) || trigger)) {
          event.preventDefault();
          closeButton.focus({ preventScroll: true });
          return;
        }
        if (event.target !== trigger || trigger.matches('button, a[href]') || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        if (!event.repeat) open(entry);
      }, { signal: controller.signal });
      closeButton.addEventListener('click', () => close(true), { signal: controller.signal });
      closeButton.addEventListener('keydown', event => {
        if (event.key === 'Tab' && event.shiftKey && bubble.parentElement === document.body) {
          event.preventDefault();
          (triggerControls().at(-1) || trigger).focus({ preventScroll: true });
        }
      }, { signal: controller.signal });
      const observer = new MutationObserver(() => {
        if (current === entry && !visible(trigger)) close();
        else schedulePosition();
      });
      observer.observe(trigger, { attributes: true, attributeFilter: ['hidden', 'data-b2g1-locale', 'class', 'aria-hidden'], childList: true, characterData: true, subtree: true });
      entry.observer = observer;
      if (window.ResizeObserver) {
        entry.resizeObserver = new ResizeObserver(schedulePosition);
        entry.resizeObserver.observe(trigger);
      }
    });
  };

  const refresh = () => init(document);
  const cleanup = () => entries.forEach((entry, trigger) => {
    if (trigger.isConnected) return;
    if (current === entry) close();
    entry.observer.disconnect();
    entry.resizeObserver?.disconnect();
    entry.controller.abort();
    entry.bubble.remove();
    entries.delete(trigger);
  });
  const closeOutside = event => {
    if (current && !current.trigger.contains(event.target) && !current.bubble.contains(event.target)) close();
  };
  document.addEventListener('pointerdown', closeOutside, { passive: true });
  document.addEventListener('click', closeOutside, { passive: true });
  document.addEventListener('keydown', event => {
    if (current && event.key === 'Escape') {
      event.preventDefault();
      close(true);
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (current && event.target.contains(current.trigger)) close();
  });
  window.addEventListener('resize', schedulePosition, { passive: true });
  window.addEventListener('scroll', schedulePosition, { capture: true, passive: true });
  window.visualViewport?.addEventListener('resize', schedulePosition, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedulePosition, { passive: true });
  const start = () => {
    refresh();
    new MutationObserver(records => {
      cleanup();
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) init(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };
  window.frPdpPromoHelp = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
